import { useEffect } from 'react';
import ZahtjeviService from '../../service/ZahtjeviService';
import { useAppDispatch } from '../../store/hooks/hooks';
import { setDohvaceniZahtjevi } from '../../store/slice/ZahtjeviSlice';
import { Companies, Processes, Users, Zahtjev } from '../../common/types/types';
import { ZahtjeviComponent } from '../../components/zahtjevi/ZahtjeviComponent';
import { companiesToCompaniesTable, processesToProcessesTable, usersToUsersTable, zahtjevToZahtjevTable } from '../../common/utils/HelperFunction';
import CompaniesService from '../../service/CompaniesService';
import { setDohvaceniCompanies } from '../../store/slice/CompaniesSlice';
import UsersService from '../../service/UsersService';
import { setDohvaceniUsers } from '../../store/slice/UsersSlice';
import ProcessesService from '../../service/ProcessesService';
import { setReachedProcesses } from '../../store/slice/ProcessesSlice';

export const DashboardContainer = () => {
  const dispatch = useAppDispatch();

  const getZahtjevi = () => {
    ZahtjeviService.getZahtjevi().then((response) => {
      let sviZahtjevi: Array<Zahtjev> = response.data;
      ZahtjeviService.getArchivedZahtjevi().then((responseArchived) => {
        sviZahtjevi = [...sviZahtjevi, ...responseArchived.data];
        dispatch(setDohvaceniZahtjevi(zahtjevToZahtjevTable(sviZahtjevi)));
      });
    });
  };

  const getCompanies = () => {
    CompaniesService.getCompanies().then((response) => {
      dispatch(setDohvaceniCompanies(companiesToCompaniesTable(response.data as Array<Companies>)));
    });
  };

  const getUsers = () => {
    UsersService.getUsers().then((response) => {
      dispatch(setDohvaceniUsers(usersToUsersTable(response.data as Array<Users>)));
    });
  };

  const getProcesses = () => {
    ProcessesService.getProcesses().then((response) => {
      dispatch(setReachedProcesses(processesToProcessesTable(response.data as Array<Processes>)));
    });
  };

  useEffect(() => {
    getZahtjevi();
    getCompanies();
    getUsers();
    getProcesses();
  });

  return (
    <>
      <ZahtjeviComponent />
      {/* <UploadPDF /> */}
    </>
  );
};
